import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
    constructor(public translate: TranslateService) {
        super();

        setTimeout(()=>{
            this.getAndInitTranslations();
        }, 1000);
        
    }

    getAndInitTranslations() {
        this.translate.get(["viewAndFine.items_per_page", "viewAndFine.next", "viewAndFine.previous"]).subscribe((translation) => {
            if (translation) {
                this.itemsPerPageLabel = translation['viewAndFine.items_per_page'];
                this.nextPageLabel = translation['viewAndFine.next'];
                this.previousPageLabel = translation['viewAndFine.previous'];
                this.changes.next();
            }
        })
    }

    override getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0 || pageSize === 0) {
            return `0 / ${length}`;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} / ${length}`;
    }
}




